import { Switch } from '@headlessui/react';
import React from 'react';

type TogglerProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
};

export function Toggler({ checked, onChange, children }: TogglerProps) {
  return (
    <Switch.Group>
      <div className="flex items-center justify-between mx-2 my-1">
        <Switch.Label className="text-sm text-wrap">{children}</Switch.Label>
        <Switch
          checked={checked}
          onChange={onChange}
          className={`${
            checked ? 'bg-primary-active' : 'bg-gray-600'
          } relative inline-flex h-4 w-9 flex-none items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}
        >
          <span
            className={`${
              checked ? 'translate-x-5' : 'translate-x-1'
            } inline-block h-3 w-3 transform rounded-full bg-white transition-transform`}
          />
        </Switch>
      </div>
    </Switch.Group>
  );
}
